import { css } from 'styled-components';

const VARIANTS = { info: '#7A6DC9', error: '#E96873', success: '#1CC982' };
const POSITIONS = ['top', 'right', 'bottom', 'left'];

const getTooltipPositionsVariants = (color: string): string => {
  return POSITIONS.reduce((acc, pos) => {
    return (
      acc +
      `
    &.place-${pos} {
      &:after {
        border-${pos}-color: ${color};
      }
    }`
    );
  }, '');
};

const getTooltipTypesVariants = (): string => {
  return Object.keys(VARIANTS).reduce((acc, type) => {
    return (
      acc +
      `
      &.type-${type} {
        background: ${VARIANTS[type]};
        ${getTooltipPositionsVariants(VARIANTS[type])}
      }`
    );
  }, '');
};

export default css`
  ${getTooltipTypesVariants()}
`;
